import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebhookIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3332 25.2552C21.8665 25.2552 20.6665 24.0429 20.6665 22.5613C20.6665 21.0797 21.8665 19.8674 23.3332 19.8674C24.7998 19.8674 25.9998 21.0797 25.9998 22.5613C25.9998 24.0429 24.7998 25.2552 23.3332 25.2552Z",
			fill: "#37474F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.3337 29.296C21.3337 29.296 19.4004 28.3532 18.1337 26.8042L20.2004 25.1205C20.9337 26.0634 22.1337 26.6695 23.3337 26.6695C25.5337 26.6695 27.3337 24.8511 27.3337 22.6287C27.3337 20.4062 25.5337 18.5879 23.3337 18.5879C22.667 18.5879 22.0004 18.7899 21.4004 19.0593L20.267 19.7328L15.5337 11.1124L17.867 9.83276L21.4004 16.1634C22.067 15.9613 22.7337 15.8266 23.4004 15.8266C27.067 15.8266 30.067 18.8573 30.067 22.5613C30.067 26.2654 27.0004 29.296 23.3337 29.296Z",
			fill: "#37474F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33317 29.2957C5.6665 29.2957 2.6665 26.2651 2.6665 22.561C2.6665 19.463 4.73317 16.8365 7.6665 16.0283L8.33317 18.6549C6.59984 19.1263 5.33317 20.7426 5.33317 22.561C5.33317 24.7834 7.13317 26.6018 9.33317 26.6018C11.5332 26.6018 13.3332 24.7834 13.3332 22.561V21.214H23.3332V23.9079H15.8665C15.2665 27.0059 12.5332 29.2957 9.33317 29.2957Z",
			fill: "#37474F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33317 25.2552C7.8665 25.2552 6.6665 24.0429 6.6665 22.5613C6.6665 21.0797 7.8665 19.8674 9.33317 19.8674C10.7998 19.8674 11.9998 21.0797 11.9998 22.5613C11.9998 24.0429 10.7998 25.2552 9.33317 25.2552Z",
			fill: "#E91E63"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6667 13.1326C15.2 13.1326 14 11.9204 14 10.4388C14 8.95712 15.2 7.74487 16.6667 7.74487C18.1333 7.74487 19.3333 8.95712 19.3333 10.4388C19.3333 11.9204 18.1333 13.1326 16.6667 13.1326Z",
			fill: "#37474F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4674 23.2347L8.20068 21.8878L12.134 15.3551C10.8007 14.0755 10.0007 12.3245 10.0007 10.4388C10.0007 6.73471 13.0007 3.7041 16.6673 3.7041C20.334 3.7041 23.334 6.73471 23.334 10.4388C23.334 11.0449 23.2674 11.5837 23.134 12.1225L20.534 11.449C20.6007 11.1123 20.6673 10.7755 20.6673 10.4388C20.6673 8.21635 18.8673 6.39798 16.6673 6.39798C14.4673 6.39798 12.6673 8.21635 12.6673 10.4388C12.6673 11.8531 13.4007 13.1327 14.6007 13.8735L15.734 14.547L10.4674 23.2347Z",
			fill: "#E91E63"
		})
	]
});
export default SvgWebhookIcon;
